import React from 'react';
import { Link } from 'react-router-dom';

const pricing = [
    {
        li1: 'Mindful Workshops',
        li2: 'Reflect, Realign and Rediscover purpose',
        li3: 'Nature Immersion',
        li4: 'Breath, Wander and Reconnect',
        li5: 'Community Circles',
        li6: 'Honest Talks, Shared Growth Journeys',
        title: 'The Reset Project',
        price: 'Z_Meghalaya',
        day: 'October 18, 2025',
        link: '/z-meghalaya',   
    },
    {
        li1: 'Interactive Panels',
        li2: 'Ideas that inspire collaboration',
        li3: 'Collaboration Labs',
        li4: 'Create, co-build, and innovate together',
        li5: 'Network Evenings',
        li6: 'Conversations over food and fire',
        title: 'The Connect Tour',
        price: 'Z_Arunachal',
        active: 'active',
        day: 'November 22, 2025',
        link: '/z-arunachal',   
    },
    {
        li1: 'Creative Retreats',
        li2: 'Pause, reflect and ideate freely',
        li3: 'Winter Dialogues',
        li4: 'Fireside stories that spark thought',
        li5: 'Mountain Escapes',
        li6: 'Explore, unwind and feel inspired',
        title: 'The Chilly Escape',
        price: 'Z_Himachal',
        day: 'January 10, 2026',
        link: '/z-himachal',   
    },
];

const Pricing3 = () => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <section className="price-two">
            <div className="auto-container">
                <div className="sec-title title-anim centered">
                    <div className="sec-title_title">Where will you reconnect?</div>
                    <h2 className="sec-title_heading">Choose your next retreat</h2>
                </div>
                <div className="row clearfix">
                    {pricing.map((item, index) => (
                        <div className="price-block_two col-lg-4 col-md-6 col-sm-12" key={index}>
                            <div className="price-block_two-inner">
                                <span className="price-block_two-color_layer"></span>
                                <div className="price-block_two-time">{item.day}</div>
                                <div className="price-block_two-title">{item.title}</div>
                                <div className="price-block_two-date">{item.price}</div>
                                <div className="price-block_two-content">
                                    <ul className="price-block_two-options">
                                        <li><strong>{item.li1}</strong>{item.li2}</li>
                                        <li className="light"><strong>{item.li3}</strong>{item.li4}</li>
                                        <li className="light"><strong>{item.li5}</strong>{item.li6}</li>
                                    </ul>
                                    <div className="price-block_two-button">
                                        <Link 
                                            onClick={ClickHandler} 
                                            to={item.link} // 👈 dynamic link per card
                                            className="theme-btn btn-style-one"
                                        >
                                            <span className="btn-wrap">
                                                <span className="text-one">Know More</span>
                                                <span className="text-two">Know More</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Pricing3;
